﻿import VeilederOblDto from '../Models/VeilederOblDto';
import { RadioButtonValgModel } from '../../Shared/Scripts/Components/RadioButtonValg';

const bachelorMaster = 'b1-bachelorMaster';
const enkeltemnerSemester = 'b2-enkeltemnerSemester';
const bachelorMasterx = 'b3-bachelorMaster';
const enkeltemnerSemesterx = 'b4-enkeltemnerSemester';
const utveksling = 'b5-utveksling';

const bValg: RadioButtonValgModel<VeilederOblDto>[] = [
    { id: 'b1', value: bachelorMaster, tekst: 'valgGradJa' },
    { id: 'b2', value: enkeltemnerSemester, tekst: 'valgGradNei' },
];

const bxValg: RadioButtonValgModel<VeilederOblDto>[] = [
    { id: 'b3', value: bachelorMasterx, tekst: 'valgGradJa' },
    { id: 'b4', value: enkeltemnerSemesterx, tekst: 'valgGradNei' },
    { id: 'b5', value: utveksling, tekst: 'valgGradUtveksling' },
];

export default {
    b1_bachelorMaster: bachelorMaster,
    b2_enkeltemnerSemester: enkeltemnerSemester,
    b3_bachelorMasterx: bachelorMasterx,
    b4_enkeltemnerSemesterx: enkeltemnerSemesterx,
    b5_utveksling: utveksling,
    bValg,
    bxValg,
};
